import { boolean, object } from "superstruct";

export const GrowaveStorefrontValuesWatermarkSchema = object({
    canShowWatermark: boolean(),
});
